<template>
	<!-- добавление новой деревни в открытый список целей -->
	<div ng-if="overlayController" class="windowOverlay" id="farmListAddVillage" ng-controller="overlayController">
		<div class="darkener clickable" clickable="closeOverlay()" @click="gameModel.buildings.area.farmListAddVillageShow = false"></div>
		<div ng-include="" src="overlayConfig['inWindowPopupTemplate']" dynamic-height="true" dynamic-max-height="706">
			<div class="inWindowPopup" ng-class="{warning: overlayConfig['isAWarning']}">
				<div class="inWindowPopupHeader">
					<h4 translate="" options="FarmList.ListAddVillage.headline" ng-if="overlayConfig['inWindowPopupTitle'] != ''"><span>Добавить деревню в список целей</span></h4>
					<h4 ng-if="overlayConfig['inWindowPopupTitleText'] != ''"></h4>
					<a class="closeOverlay clickable" clickable="closeOverlay()" translate=""><span>Закрыть</span></a>
				</div>
				<div class="inWindowPopupContent">
					<div ng-include="" src="overlayConfig['inWindowPopupContentTemplate']">
						<div class="farmListAddVillage">
							<div class="searchVillage" check-target-fct="checkTarget" api="villageSearch">
								<h6 translate=""><span>Цель</span></h6>
								<div class="error success" ng-class="{success: api.result.villageReturned}">
									<span class="villageName serverautocompleteContainer ng-valid ng-dirty ng-valid-parse" disable-search="" autocompletedata="playerVillages,village,coords,emptyCoords" autocompletecb="selectVillage" ng-model="api.result.villageSearched" input-autofocus="true" show-own-villages="false">
										<!-- ngIf: showOwnVillages -->
										<span role="status" aria-live="polite" class="ui-helper-hidden-accessible"></span>
										<input ng-disabled="disabledInput" class="targetInput ng-pristine ng-valid ui-autocomplete-input ng-touched" type="text" ng-model="modelInput" ng-focus="onFocus();hideOwnVillagesList();" autocomplete="off" placeholder="Поиск..." />
										<label ng-class="{ownVillagesShown: showOwnVillages}" style="width: 136px;">
											<i class="action_search_tiny_flat_white"></i>
											Игрок, Деревня, Координаты
										</label>
										<!-- ngIf: showOwnVillages -->
									</span>
								</div>
								<div ng-show="api.target.villageId > 0" class="">
									<div class="horizontalLine"></div>
									<table class="transparent">
										<tbody>
											<tr>
												<th translate=""><span>Деревня</span></th>
												<td>
													<a ng-class="{disabled: villId <= 2 || nolink}" class="villageLink truncated clickable" clickable="$root.openWindow('mapCellDetails', {'cellId': 535183346}, null, true)" village-link="" villageid="535183346" villagename="04.">04.</a>
												</td>
											</tr>
											<tr ng-if="api.target.destPlayerId !== null">
												<th translate=""><span>Владелец</span></th>
												<td data-village-type="" data-is-governor-npc="" class="playerVillage">
													<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="553">Труррль</a>
												</td>
											</tr>
											<tr ng-if="api.targetPlayer.data.kingdomId > 0">
												<th translate=""><span>Королевство</span></th>
												<td>
													<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 10}, null, true)" kingdomid="10">ОоО</a>
												</td>
											</tr>
											<tr ng-show="showDuration && showDuration != 'false'" class="ng-hide">
											<th translate=""><span>Время</span></th>
												<td>0</td>
											</tr>
											<tr ng-show="showDistance && showDistance != 'false'" class="ng-hide">
											<th translate=""><span>Дист.</span></th>
												<td></td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
						<div class="buttonFooter">
							<div ng-if="error" class="error" translate="" options="Error.TargetOwnVillage"><span>Ты не можешь добавить свою собственную деревню в список.</span></div>
							<button clickable="addVillage()" ng-class="{disabled: villageId == 0 || error}" class="clickable disabled">
								<div class="content">
									<span ng-transclude="" class="innerText">
										<span translate=""><span>Добавить</span></span>
									</span>
									<!-- ngIf: price > 0 || forceGoldUsage -->
									<!-- ngIf: price == -1 && !forceGoldUsage -->
									<div class="animationOverlay"></div>
									<i class="checkmark action_check_small_flat_white"></i>
									<i class="checkmark action_check_small_flat_black"></i>
									<i class="checkmark action_check_small_flat_red"></i>
								</div>
							</button>
							<button clickable="closeOverlay();" @click="gameModel.buildings.area.farmListAddVillage = false" class="cancel clickable">
								<div class="content">
									<span ng-transclude="" class="innerText">
										<span translate=""><span>Отмена</span></span>
									</span>
									<!-- ngIf: price > 0 || forceGoldUsage -->
									<!-- ngIf: price == -1 && !forceGoldUsage -->
									<div class="animationOverlay"></div>
									<i class="checkmark action_check_small_flat_white"></i>
									<i class="checkmark action_check_small_flat_black"></i>
									<i class="checkmark action_check_small_flat_red"></i>
								</div>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	components: {},
}
</script>